import styled, { css } from "styled-components";


export const TitleForm = styled.span`
    font-size: 18px;
    font-weight: 700;
    font-family: Inter, sans-serif;
    color: #231F20;
    text-transform: uppercase;

 
`

interface TitleContainerProps {
  marginTop?: number;
  marginBottom?: number;
}

export const TitleContainer = styled.div<TitleContainerProps>`

${props => props.marginTop !== undefined && props.marginTop > 0 ?
    css`
      margin-top: ${props.marginTop * 8}px;   
  ` : null
  }


 ${props => props.marginBottom !== undefined && props.marginBottom > 0 ?
    css`
      margin-bottom: ${props.marginBottom * 8}px;   
  ` : null
  }

`



export const Divider = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #E0E0E0;
  margin: 1em 0;
  padding: 0;
`